import { getConsumptionDataBySubjectID } from "../../../services/apiCalls.js";
import { format } from "date-fns";

export const fetchUserConsumptionData = async (
  selectedUser,
  setConsumptionData
) => {
  try {
    const allConsumptionData = await getConsumptionDataBySubjectID(
      selectedUser
    );
    const formattedConsumptionData = allConsumptionData.map((data) => ({
      date: format(new Date(data.date), "yyyy-MM-dd"),
      calories: data.calories === 0 ? null : data.calories,
      water: data.water === 0 ? null : data.water,
      coffee: data.coffee === 0 ? null : data.coffee,
      refreshment: data.refreshment === 0 ? null : data.refreshment,
      tea: data.tea === 0 ? null : data.tea,
      alcohol: data.alcohol === 0 ? null : data.alcohol,
    }));
    setConsumptionData(formattedConsumptionData);
    // console.log(
    //   "consumption data in consumptionEndpoint file: ",
    //   formattedConsumptionData
    // );
  } catch (error) {
    console.error(
      "Error fetching consumption data in consumption components:",
      error
    );
  }
};
